import { render, staticRenderFns } from "./customEmissionFactorDialog.vue?vue&type=template&id=23529295&scoped=true&"
import script from "./customEmissionFactorDialog.vue?vue&type=script&lang=js&"
export * from "./customEmissionFactorDialog.vue?vue&type=script&lang=js&"
import style0 from "./customEmissionFactorDialog.vue?vue&type=style&index=0&id=23529295&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23529295",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QScrollArea,QTabs,QTab,QIcon,QBtn,QTabPanels,QTabPanel,QForm,QInput});
